



import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import SvgRender from "@/components/Atoms/SvgRender/SvgRender.vue";

@Component({
  components: {
    SvgRender
  }
})
export default class SelectBaby extends Vue {
  @Prop(String) babyName!: string
  @Prop(String) avatar!: string
  @Prop({type: Boolean, default: false}) verify!: boolean

  private get babyAvatar(): string {
    if (this.avatar) return this.avatar
    return require('@/assets/images/default-avatar.png')
  }
}
